import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false,
  ...props
}: CardProps) {
  return <div className={`glass-panel rounded-xl overflow-hidden ${hover ? 'transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_-15px_rgba(200,169,106,0.2)] hover:border-navy-600' : ''} ${className}`} {...props} data-id="element-246">
      {children}
    </div>;
}